import Vue from "vue";
import VueRouter from "vue-router";
import { routerBefore } from './permission';
Vue.use(VueRouter);
const routes = [
  {
    path: "/list",
    name: "CareerList",
    component: () => import('../views/list'),
    meta: {
      title: '职业路径列表_翼狐网',
    },
  },
  {
    path: "/(career)*/:career_id",
    name: "Career",
    component: () => import('../views/career'),
    meta: {
      title: '职业路径专题购买_翼狐网',
    },
  },
  {
    path: '*',
    name: "other",
    redirect: "/error"
  },
];
console.log("process.env.NODE_ENV", process.env.NODE_ENV)
console.log("process.env.ENV", process.env.ENV)
const router = new VueRouter({
  mode: "history",
  // mode: process.env.NODE_ENV == "development" ? "hash" : "history",
  base: "/career",
  routes,
});

// 路由拦截
router.beforeEach(routerBefore);

export default router;
